import React, { useMemo } from 'react';
// import { regexForStartLinks } from 'utils/constants';
// import { Rule } from 'antd/lib/form';
// import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IAppStoreLink {
	changeAppStoreLink: (value: string) => void;
}

const AppStoreLink: React.FC<IAppStoreLink> = ({ changeAppStoreLink }) => {
	// const { t } = useTranslation('error');
	// const validationRules = useMemo<Rule[]>(
	// 	() => [
	// 		{ required: true, message: t('enterAppStoreMarketLink') },
	// 		() => ({
	// 			validator(_, value) {
	// 				if (value && !value.match(regexForStartLinks)) {
	// 					return Promise.reject(new Error(t('linkMustStartWithHttp')));
	// 				}
	// 				return Promise.resolve();
	// 			},
	// 		}),
	// 	],
	// 	[t],
	// );

	return (
		<FormInput
			testId="AppStoreLinkField"
			name="appStoreLink"
			label="appStoreMarketLinkLabel"
			onChange={changeAppStoreLink}
			// validationRules={validationRules}
		/>
	);
};

export default React.memo(AppStoreLink);
